import { useState } from "react";
import { httpsUrl } from "../../project/schema";
import { useProject, useServices } from "../context";
import { Panel } from "./controls";

/** Song metadata for band use: title, artist, performance notes, reference links (https only). */
export function SongDetails() {
  const { controller } = useServices();
  const song = useProject((p) => p.song);
  const id = useProject((p) => p.id);
  const [label, setLabel] = useState("");
  const [url, setUrl] = useState("");
  const [error, setError] = useState<string | null>(null);
  const set = (patch: Partial<typeof song>) => controller.updateProject((p) => ({ ...p, song: { ...p.song, ...patch } }));

  return (
    <Panel title="Song details">
      <div className="controls-grid" key={id}>
        <label className="field"><span>Title</span><input defaultValue={song.title} maxLength={200} onBlur={(e) => { if (e.currentTarget.value !== song.title) set({ title: e.currentTarget.value }); }} /></label>
        <label className="field"><span>Artist</span><input defaultValue={song.artist} maxLength={200} onBlur={(e) => { if (e.currentTarget.value !== song.artist) set({ artist: e.currentTarget.value }); }} /></label>
      </div>
      <label className="field" key={`n-${id}`}>
        <span>Performance notes</span>
        <textarea rows={3} defaultValue={song.notes} maxLength={4000} placeholder="Structure, cues, who starts, capo…" onBlur={(e) => { if (e.currentTarget.value !== song.notes) set({ notes: e.currentTarget.value }); }} />
      </label>
      <h3>Links</h3>
      {song.references.length > 0 && (
        <ul className="reference-list">
          {song.references.map((r, i) => (
            <li key={`${r.url}-${i}`}>
              <a href={r.url} target="_blank" rel="noopener noreferrer">{r.label}</a>
              <button type="button" aria-label={`Remove link ${r.label}`} onClick={() => set({ references: song.references.filter((_, j) => j !== i) })}>✕</button>
            </li>
          ))}
        </ul>
      )}
      <form className="controls-row" onSubmit={(e) => {
        e.preventDefault();
        const parsed = httpsUrl.safeParse(url.trim());
        if (!label.trim() || !parsed.success) { setError("Enter a label and an https:// link."); return; }
        if (song.references.length >= 10) { setError("Up to 10 links per song."); return; }
        set({ references: [...song.references, { label: label.trim().slice(0, 120), url: parsed.data }] });
        setLabel(""); setUrl(""); setError(null);
      }}>
        <input aria-label="Link label" placeholder="Chord chart" value={label} onChange={(e) => setLabel(e.currentTarget.value)} />
        <input aria-label="Link URL" placeholder="https://…" value={url} onChange={(e) => setUrl(e.currentTarget.value)} />
        <button type="submit">Add link</button>
      </form>
      {error && <p className="status warn" role="alert">{error}</p>}
      <p className="hint">Only link to material you are entitled to use. Links open in a new tab.</p>
    </Panel>
  );
}
